<template>
	<div class="sidebar">
		<div class="sidebar-content">
			<div class="details">
				<div class="edit-wrapper">
					<i class="fas fa-pen" style="color: #fff; font-size: 12px;"></i>
				</div>
				<div class="row">
					<div class="col-5 title">Date</div>
					<div class="col-7 description">{{ date }}</div>
				</div>
				<div class="row">
					<div class="col-5 title">Shift</div>
					<div class="col-7 description">{{ shiftTimeString }}</div>
				</div>
				<div class="row">
					<div class="col-5 title">Position</div>
					<div class="col-7 description">{{ position }}</div>
				</div>
				<div class="row">
					<div class="col-5 title">Events</div>
					<div class="col-7 description">{{ event }}</div>
				</div>
				<div class="row">
					<div class="col-5 title">Weather</div>
					<div class="col-7 description">{{ weather }}</div>
				</div>
			</div>
			<transition name="fade">
				<div class="employees-wrapper" v-if="isShiftAssigned">
					<h2 class="title">Assigned To</h2>

					<div class="employees">
						<employee
							v-if="employeeFullName === 'Randy Goodman'"
							:id="1"
							:index="1"
							fullName="Randy Goodman"
							workedHours="30"
							statusColor="#7cc230"
							:tagList="[1]"
							:reasonList="[1]"
							initials="RG"
							@assignShift="hanleAssignShiftClick"
						/>
						<employee
							v-else
							:id="2"
							:index="2"
							fullName="Jeff Miller"
							workedHours="10"
							statusColor="#7cc230"
							:tagList="[1]"
							:reasonList="[1]"
							initials="JM"
							@assignShift="hanleAssignShiftClick"
						>
							<template v-slot:actionButtor>
								Release
							</template>
						</employee>
					</div>
				</div>
			</transition>
			<transition name="fade">
				<div class="employees-wrapper" v-if="shiftId">
					<h2 class="title">Employees</h2>

					<div class="employees">
						<employee
							v-for="(employee, index) in employeeList"
							:key="index"
							:index="index"
							:id="employee.id"
							:fullName="employee.fullName"
							:workedHours="employee.workedHours"
							:weeklyHours="employee.weeklyHours"
							:reasonList="employee.reasonList"
							:tagList="employee.tagList"
							:statusColor="employee.statusColor"
							:initials="employee.initials"
							@assignShift="hanleAssignShiftClick"
						/>
					</div>

					<button class="action-button">Send Request via SMS</button>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import employee from '@/components/employee';
import { employeeList, shuffle } from '../api';

export default {
	name: 'sidebar',
	components: { employee },
	props: {
		shiftId: { required: false, type: Number },
		isShiftAssigned: { required: false },
		employeeFullName: { required: false },
		date: { required: false, type: String, default: () => '-' },
		shiftTimeString: { required: false, type: String, default: () => '-' },
		position: { required: false, type: String, default: () => '-' },
		event: { required: false, type: String, default: () => '-' },
		weather: { required: false, type: String, default: () => '-' },
	},
	data() {
		return {
			employeeList: [...employeeList],
			currentShift: {},
		};
	},
	mounted() {
		// this.employeeList = shuffle(this.employeeList);
	},
	computed: {},
	watch: {
		shiftId() {
			// this.employeeList = shuffle(this.employeeList);
			this.currentShift = this.employeeList.find(x => x.id === this.employeeName);
		},
	},
	methods: {
		hanleAssignShiftClick() {
			// employeeId
			// console.log('assign shift clicked from employee', employeeId);
		},
	},
};
</script>

<style lang="scss" scoped>
.sidebar {
	position: relative;
	width: 100%;
	flex: 0 0 20%;
	max-width: 20%;
	height: 100vh;
	padding-right: 15px;
	padding-left: 15px;
	padding-top: 15px;

	.sidebar-content {
		// position: fixed;
		// top: 20px;

		.details {
			width: 100%;
			position: relative;
			padding: 10px;
			border-radius: 3px;
			background-color: #f7f8f9;

			.title,
			.description {
				font-size: 13px;
				color: #616e84;
				text-align: left;
			}
			.title {
			}
			.description {
				font-weight: bold;
			}

			.edit-wrapper {
				position: absolute;
				top: 10px;
				right: 10px;
				width: 28.6px;
				height: 28.6px;
				border-radius: 50%;
				background-color: #616e84;
			}
		}
		.employees-wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: flex-start;
			margin-top: 20px;

			& > .title {
				font-size: 15px;
				font-weight: bold;
				color: #616e84;
			}
			.employees {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: flex-start;
				width: 100%;
				margin-bottom: 50px;
			}
			.action-button {
				width: 278px;
				height: 36px;
				border-radius: 3px;
				font-size: 13px;

				background-color: #616e84;
				color: #ffffff;
			}
		}
	}
}
</style>
